import { getProjectAdres } from '@util/project-util'

import type { Project } from '../../aansluiting/project/types/Project'

interface Props {
  postcode?: string
  plaats?: string
  straatNaam?: string
  huisnummer?: string
  toevoeging?: string
}

export default function Adres({
  postcode,
  plaats,
  straatNaam,
  huisnummer,
  toevoeging,
}: Props) {
  if (straatNaam) {
    const nummer = toevoeging ? `${huisnummer} ${toevoeging}` : huisnummer

    return (
      <>
        <span>
          {straatNaam} {nummer}
        </span>
        <br />
        <span>
          {postcode} {plaats}
        </span>
      </>
    )
  }

  return (
    <>
      {postcode} {plaats}
    </>
  )
}

export function ProjectAdres(project: Project) {
  const adresText = getProjectAdres(project)

  if (!adresText) return ''

  const lines = adresText.split('\n')

  if (lines.length > 1) {
    return lines.map((part, i) => (
      <span key={i}>
        {part}
        {i < lines.length - 1 && <br />}
      </span>
    ))
  }

  return adresText
}
